import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DialogPopupComponent } from '../dialog-popup/dialog-popup.component';
import { Router } from '@angular/router';
import { ResetStartpageService } from '../../services/reset-startpage-service/reset-startpage.service';
import { AppFinderDataService } from '../../services/appfinder-service/app-finder-data.service';
import { UserGuideStartRequestService } from '../../services/user-guide-start-request/user-guide-start-request.service';
import { FolderService } from '../../services/folder-service/folder.service';
import { FolderUiService } from '../../../pages/start-page/services/folder-ui.service';
import { WidgetUIService } from '../../../pages/start-page/services/widget-ui.service';
import { FolderStateService } from '../../services/folder-service/folder-state.service';
import { NavigationSetup } from '../../services/navigation-items-service/navigation-setup';
import { AppButtonComponent } from '../app-button/app-button.component';
import { ButtonTypeEnum } from '../../enums/buttonType.enum';

@Component({
  selector: 'reset-start-page-confirmation-dialog',
  imports: [DialogPopupComponent, AppButtonComponent],
  templateUrl: './reset-start-page-confirmation-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-start-page-confirmation-dialog.component.scss',
})
export class ResetStartPageConfirmationDialogComponent {
  @ViewChild('dialog') dialogPopupComponent!: DialogPopupComponent;

  public static instance: ResetStartPageConfirmationDialogComponent;

  constructor(
    private router: Router,
    private resetStartPageService: ResetStartpageService,
    private appFinderDataService: AppFinderDataService,
    private userGuideStartRequest: UserGuideStartRequestService,
    private folderService: FolderService,
    private folderUiService: FolderUiService,
    private widgetUiService: WidgetUIService,
    private folderStateService: FolderStateService,
  ) {
    ResetStartPageConfirmationDialogComponent.instance = this;
  }

  openDialog(): void {
    this.dialogPopupComponent.openDialog();
  }

  doReset(): void {
    this.dialogPopupComponent.closeDialog();

    this.resetStartPageService.resetStartPage().subscribe(() => {
      this.userGuideStartRequest.markPendingOpenFromMenu();
      this.router
        .navigate([NavigationSetup.START_PAGE.path], {
          queryParams: {
            showTab: 'My Apps',
          },
          onSameUrlNavigation: 'reload',
        })
        .then(() => {
          this.userGuideStartRequest.completePendingOpenAfterNavigate();
        });

      this.appFinderDataService.fetchAllApps().subscribe(() => {
        this.appFinderDataService.getAllApps().subscribe((_allApps) => {
          this.widgetUiService.apps.set(_allApps);
          this.folderService.getFolders().subscribe((_folders) => {
            this.folderUiService.folders = _folders;

            if (
              !this.folderUiService.getSelectedFolder()() ||
              this.folderUiService.folders.length > 0
            ) {
              const currentFolderId = this.folderStateService.getCurrentFolderId();

              if (currentFolderId) {
                const selectedFolder = _folders.find((f) => f.id === currentFolderId);
                if (selectedFolder) {
                  this.folderUiService.setSelectedFolder(selectedFolder);
                } else {
                  this.folderUiService.setSelectedFolder(_folders[0]);
                }
              } else {
                this.folderUiService.setSelectedFolder(_folders[0]);
              }
            }
          });
        });
      });
    });
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
